
export enum MeddraLevel {
  SOC = "SOC Terms",
  HLGT = "HLGT Terms",
  HLT = "HLT Terms",
  PT = "Preferred Terms",
  LLT = "Low Level Terms"
}
;

export enum HierarchyMode {
  ASCENDING,
  DESCENDING
}
